var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.494,
    height: 19.017,
    viewBox: "0 0 21.494 19.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10",
    "data-name": "\\u8DEF\\u5F84 10",
    d: "M21,2H1V21H13l.72-5.05L14,14l7-2Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u767B\\u5F55",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_1",
    "data-name": "\\u7EC4 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_9",
    "data-name": "\\u8DEF\\u5F84 9",
    d: "M18.61,17.77l-5.22-2.58c-.24-.12-.4-.71-.4-1v-.68a5.54,5.54,0,0,0,3-5A5.27,5.27,0,0,0,11,3,5.27,5.27,0,0,0,6,8.5a5.54,5.54,0,0,0,3,5v.64c0,.26-.18.89-.42,1L3.39,17.77a.67.67,0,0,0-.39.62V19.5a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5V18.39a.67.67,0,0,0-.39-.62Z",
    fill: "none",
    stroke: "#505050",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\u76F4\\u7EBF_1",
    "data-name": "\\u76F4\\u7EBF 1",
    x2: 2.2,
    y2: 2.1,
    transform: "translate(14.49 18.21)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u76F4\\u7EBF_2",
    "data-name": "\\u76F4\\u7EBF 2",
    y1: 5.94,
    x2: 4.86,
    transform: "translate(16.93 14.35)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjEuNDk0IiBoZWlnaHQ9IjE5LjAxNyIgdmlld0JveD0iMCAwIDIxLjQ5NCAxOS4wMTciPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwLXBhdGgiPgogICAgICA8cGF0aCBpZD0i6Lev5b6EXzEwIiBkYXRhLW5hbWU9Iui3r+W+hCAxMCIgZD0iTTIxLDJIMVYyMUgxM2wuNzItNS4wNUwxNCwxNGw3LTJaIiBmaWxsPSJub25lIi8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KICA8ZyBpZD0i55m75b2VIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMSAtMikiPgogICAgPGcgaWQ9Iue7hF8xIiBkYXRhLW5hbWU9Iue7hCAxIiBjbGlwLXBhdGg9InVybCgjY2xpcC1wYXRoKSI+CiAgICAgIDxwYXRoIGlkPSLot6/lvoRfOSIgZGF0YS1uYW1lPSLot6/lvoQgOSIgZD0iTTE4LjYxLDE3Ljc3bC01LjIyLTIuNThjLS4yNC0uMTItLjQtLjcxLS40LTF2LS42OGE1LjU0LDUuNTQsMCwwLDAsMy01QTUuMjcsNS4yNywwLDAsMCwxMSwzLDUuMjcsNS4yNywwLDAsMCw2LDguNWE1LjU0LDUuNTQsMCwwLDAsMyw1di42NGMwLC4yNi0uMTguODktLjQyLDFMMy4zOSwxNy43N2EuNjcuNjcsMCwwLDAtLjM5LjYyVjE5LjVhLjUuNSwwLDAsMCwuNS41aDE1YS41LjUsMCwwLDAsLjUtLjVWMTguMzlhLjY3LjY3LDAsMCwwLS4zOS0uNjJaIiBmaWxsPSJub25lIiBzdHJva2U9IiM1MDUwNTAiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8L2c+CiAgICA8bGluZSBpZD0i55u057q/XzEiIGRhdGEtbmFtZT0i55u057q/IDEiIHgyPSIyLjIiIHkyPSIyLjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0LjQ5IDE4LjIxKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNTA1MDUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8bGluZSBpZD0i55u057q/XzIiIGRhdGEtbmFtZT0i55u057q/IDIiIHkxPSI1Ljk0IiB4Mj0iNC44NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuOTMgMTQuMzUpIiBmaWxsPSJub25lIiBzdHJva2U9IiM1MDUwNTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjEiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };